/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AccountCollectionResponse as BackendCoreApiModelsIdentityAccountCollectionResponse } from '../models/Backend/Core/Api/Models/Identity/account-collection-response';
import { AuthenticateRequest as BackendCoreApiModelsIdentityAuthenticateRequest } from '../models/Backend/Core/Api/Models/Identity/authenticate-request';
import { AuthenticateResponse as BackendCoreApiModelsIdentityAuthenticateResponse } from '../models/Backend/Core/Api/Models/Identity/authenticate-response';
import { ChangePasswordRequest as BackendCoreApiModelsIdentityChangePasswordRequest } from '../models/Backend/Core/Api/Models/Identity/change-password-request';
import { DestroyAccountRequest as BackendCoreApiModelsIdentityDestroyAccountRequest } from '../models/Backend/Core/Api/Models/Identity/destroy-account-request';
import { ForgotPasswordRequest as BackendCoreApiModelsIdentityForgotPasswordRequest } from '../models/Backend/Core/Api/Models/Identity/forgot-password-request';
import { RegisterExternalAccountRequest as BackendCoreApiModelsIdentityRegisterExternalAccountRequest } from '../models/Backend/Core/Api/Models/Identity/register-external-account-request';
import { RegisterInternalAccountRequest as BackendCoreApiModelsIdentityRegisterInternalAccountRequest } from '../models/Backend/Core/Api/Models/Identity/register-internal-account-request';
import { RegisterPharmacistAccountRequest as BackendCoreApiModelsIdentityRegisterPharmacistAccountRequest } from '../models/Backend/Core/Api/Models/Identity/register-pharmacist-account-request';
import { ResetPasswordRequest as BackendCoreApiModelsIdentityResetPasswordRequest } from '../models/Backend/Core/Api/Models/Identity/reset-password-request';
import { VerifyAccountRequest as BackendCoreApiModelsIdentityVerifyAccountRequest } from '../models/Backend/Core/Api/Models/Identity/verify-account-request';
import { VerifyDestroyTokenRequest as BackendCoreApiModelsIdentityVerifyDestroyTokenRequest } from '../models/Backend/Core/Api/Models/Identity/verify-destroy-token-request';
import { VerifyPharmacistRequest as BackendCoreApiModelsIdentityVerifyPharmacistRequest } from '../models/Backend/Core/Api/Models/Identity/verify-pharmacist-request';
import { VerifyResetTokenRequest as BackendCoreApiModelsIdentityVerifyResetTokenRequest } from '../models/Backend/Core/Api/Models/Identity/verify-reset-token-request';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class IdentityBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation authenticate
   */
  static readonly AuthenticatePath = '/api/identity/authenticate';

  /**
   * Authenticate user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticate$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authenticate$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityAuthenticateRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.AuthenticatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>;
      })
    );
  }

  /**
   * Authenticate user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticate$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authenticate$Plain(params: {
    body: BackendCoreApiModelsIdentityAuthenticateRequest
  }): Observable<BackendCoreApiModelsIdentityAuthenticateResponse> {

    return this.authenticate$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>) => r.body as BackendCoreApiModelsIdentityAuthenticateResponse)
    );
  }

  /**
   * Authenticate user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticate$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authenticate$Json$Response(params: {
    body: BackendCoreApiModelsIdentityAuthenticateRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.AuthenticatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>;
      })
    );
  }

  /**
   * Authenticate user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticate$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authenticate$Json(params: {
    body: BackendCoreApiModelsIdentityAuthenticateRequest
  }): Observable<BackendCoreApiModelsIdentityAuthenticateResponse> {

    return this.authenticate$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>) => r.body as BackendCoreApiModelsIdentityAuthenticateResponse)
    );
  }

  /**
   * Path part for operation changePassword
   */
  static readonly ChangePasswordPath = '/api/identity/change-password';

  /**
   * Change password for authenticated account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changePassword$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changePassword$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityChangePasswordRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.ChangePasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Change password for authenticated account.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `changePassword$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changePassword$Plain(params: {
    body: BackendCoreApiModelsIdentityChangePasswordRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.changePassword$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Change password for authenticated account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changePassword$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changePassword$Json$Response(params: {
    body: BackendCoreApiModelsIdentityChangePasswordRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.ChangePasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Change password for authenticated account.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `changePassword$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changePassword$Json(params: {
    body: BackendCoreApiModelsIdentityChangePasswordRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.changePassword$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation destroyAccount
   */
  static readonly DestroyAccountPath = '/api/identity/destroy-account';

  /**
   * Destroy a user account. Irreversible user account deletion. Deletes all connected records in database.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destroyAccount$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  destroyAccount$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityDestroyAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.DestroyAccountPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Destroy a user account. Irreversible user account deletion. Deletes all connected records in database.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destroyAccount$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  destroyAccount$Plain(params: {
    body: BackendCoreApiModelsIdentityDestroyAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.destroyAccount$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Destroy a user account. Irreversible user account deletion. Deletes all connected records in database.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destroyAccount$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  destroyAccount$Json$Response(params: {
    body: BackendCoreApiModelsIdentityDestroyAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.DestroyAccountPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Destroy a user account. Irreversible user account deletion. Deletes all connected records in database.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destroyAccount$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  destroyAccount$Json(params: {
    body: BackendCoreApiModelsIdentityDestroyAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.destroyAccount$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation forgotPassword
   */
  static readonly ForgotPasswordPath = '/api/identity/forgot-password';

  /**
   * Forgot password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forgotPassword$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  forgotPassword$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityForgotPasswordRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.ForgotPasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Forgot password.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `forgotPassword$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  forgotPassword$Plain(params: {
    body: BackendCoreApiModelsIdentityForgotPasswordRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.forgotPassword$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Forgot password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forgotPassword$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  forgotPassword$Json$Response(params: {
    body: BackendCoreApiModelsIdentityForgotPasswordRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.ForgotPasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Forgot password.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `forgotPassword$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  forgotPassword$Json(params: {
    body: BackendCoreApiModelsIdentityForgotPasswordRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.forgotPassword$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation initiateDestroyAccount
   */
  static readonly InitiateDestroyAccountPath = '/api/identity/initiate-destroy-account';

  /**
   * Initiate full deletion of a user account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `initiateDestroyAccount$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  initiateDestroyAccount$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.InitiateDestroyAccountPath, 'delete');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Initiate full deletion of a user account.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `initiateDestroyAccount$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  initiateDestroyAccount$Plain(params?: {
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.initiateDestroyAccount$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Initiate full deletion of a user account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `initiateDestroyAccount$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  initiateDestroyAccount$Json$Response(params?: {
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.InitiateDestroyAccountPath, 'delete');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Initiate full deletion of a user account.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `initiateDestroyAccount$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  initiateDestroyAccount$Json(params?: {
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.initiateDestroyAccount$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getInternalUsers
   */
  static readonly GetInternalUsersPath = '/api/app/identity/internal-users';

  /**
   * Gets internal accounts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInternalUsers$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInternalUsers$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.GetInternalUsersPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>;
      })
    );
  }

  /**
   * Gets internal accounts.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInternalUsers$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInternalUsers$Plain(params?: {
  }): Observable<BackendCoreApiModelsIdentityAccountCollectionResponse> {

    return this.getInternalUsers$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>) => r.body as BackendCoreApiModelsIdentityAccountCollectionResponse)
    );
  }

  /**
   * Gets internal accounts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInternalUsers$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInternalUsers$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.GetInternalUsersPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>;
      })
    );
  }

  /**
   * Gets internal accounts.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInternalUsers$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInternalUsers$Json(params?: {
  }): Observable<BackendCoreApiModelsIdentityAccountCollectionResponse> {

    return this.getInternalUsers$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>) => r.body as BackendCoreApiModelsIdentityAccountCollectionResponse)
    );
  }

  /**
   * Path part for operation getPharmacistUsers
   */
  static readonly GetPharmacistUsersPath = '/api/app/identity/pharmacist-users';

  /**
   * Gets pharmacist accounts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPharmacistUsers$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacistUsers$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.GetPharmacistUsersPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>;
      })
    );
  }

  /**
   * Gets pharmacist accounts.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPharmacistUsers$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacistUsers$Plain(params?: {
  }): Observable<BackendCoreApiModelsIdentityAccountCollectionResponse> {

    return this.getPharmacistUsers$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>) => r.body as BackendCoreApiModelsIdentityAccountCollectionResponse)
    );
  }

  /**
   * Gets pharmacist accounts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPharmacistUsers$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacistUsers$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.GetPharmacistUsersPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>;
      })
    );
  }

  /**
   * Gets pharmacist accounts.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPharmacistUsers$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacistUsers$Json(params?: {
  }): Observable<BackendCoreApiModelsIdentityAccountCollectionResponse> {

    return this.getPharmacistUsers$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>) => r.body as BackendCoreApiModelsIdentityAccountCollectionResponse)
    );
  }

  /**
   * Path part for operation getPharmacyUsers
   */
  static readonly GetPharmacyUsersPath = '/api/app/identity/pharmacy-users';

  /**
   * Gets pharmacy accounts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPharmacyUsers$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyUsers$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.GetPharmacyUsersPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>;
      })
    );
  }

  /**
   * Gets pharmacy accounts.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPharmacyUsers$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyUsers$Plain(params?: {
  }): Observable<BackendCoreApiModelsIdentityAccountCollectionResponse> {

    return this.getPharmacyUsers$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>) => r.body as BackendCoreApiModelsIdentityAccountCollectionResponse)
    );
  }

  /**
   * Gets pharmacy accounts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPharmacyUsers$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyUsers$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.GetPharmacyUsersPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>;
      })
    );
  }

  /**
   * Gets pharmacy accounts.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPharmacyUsers$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyUsers$Json(params?: {
  }): Observable<BackendCoreApiModelsIdentityAccountCollectionResponse> {

    return this.getPharmacyUsers$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>) => r.body as BackendCoreApiModelsIdentityAccountCollectionResponse)
    );
  }

  /**
   * Path part for operation massResetPassword
   */
  static readonly MassResetPasswordPath = '/api/identity/mass-reset-password';

  /**
   * Resets password for all accounts which haven't been activated yet.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `massResetPassword$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  massResetPassword$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.MassResetPasswordPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Resets password for all accounts which haven't been activated yet.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `massResetPassword$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  massResetPassword$Plain(params?: {
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.massResetPassword$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Resets password for all accounts which haven't been activated yet.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `massResetPassword$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  massResetPassword$Json$Response(params?: {
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.MassResetPasswordPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Resets password for all accounts which haven't been activated yet.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `massResetPassword$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  massResetPassword$Json(params?: {
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.massResetPassword$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation refreshToken
   */
  static readonly RefreshTokenPath = '/api/identity/refresh-token';

  /**
   * Refresh users token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refreshToken$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshToken$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RefreshTokenPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>;
      })
    );
  }

  /**
   * Refresh users token.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `refreshToken$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshToken$Plain(params?: {
  }): Observable<BackendCoreApiModelsIdentityAuthenticateResponse> {

    return this.refreshToken$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>) => r.body as BackendCoreApiModelsIdentityAuthenticateResponse)
    );
  }

  /**
   * Refresh users token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refreshToken$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshToken$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RefreshTokenPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>;
      })
    );
  }

  /**
   * Refresh users token.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `refreshToken$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshToken$Json(params?: {
  }): Observable<BackendCoreApiModelsIdentityAuthenticateResponse> {

    return this.refreshToken$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>) => r.body as BackendCoreApiModelsIdentityAuthenticateResponse)
    );
  }

  /**
   * Path part for operation registerExternalUser
   */
  static readonly RegisterExternalUserPath = '/api/identity/register-external';

  /**
   * Registers a new external user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerExternalUser$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerExternalUser$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityRegisterExternalAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RegisterExternalUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Registers a new external user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `registerExternalUser$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerExternalUser$Plain(params: {
    body: BackendCoreApiModelsIdentityRegisterExternalAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.registerExternalUser$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Registers a new external user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerExternalUser$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerExternalUser$Json$Response(params: {
    body: BackendCoreApiModelsIdentityRegisterExternalAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RegisterExternalUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Registers a new external user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `registerExternalUser$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerExternalUser$Json(params: {
    body: BackendCoreApiModelsIdentityRegisterExternalAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.registerExternalUser$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation registerInternalUser
   */
  static readonly RegisterInternalUserPath = '/api/identity/register-internal';

  /**
   * Registers a new internal user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerInternalUser$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerInternalUser$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityRegisterInternalAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RegisterInternalUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Registers a new internal user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `registerInternalUser$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerInternalUser$Plain(params: {
    body: BackendCoreApiModelsIdentityRegisterInternalAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.registerInternalUser$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Registers a new internal user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerInternalUser$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerInternalUser$Json$Response(params: {
    body: BackendCoreApiModelsIdentityRegisterInternalAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RegisterInternalUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Registers a new internal user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `registerInternalUser$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerInternalUser$Json(params: {
    body: BackendCoreApiModelsIdentityRegisterInternalAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.registerInternalUser$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation registerPharmacistUser
   */
  static readonly RegisterPharmacistUserPath = '/api/identity/register-pharmacist';

  /**
   * Registers a new pharmacist user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerPharmacistUser$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerPharmacistUser$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityRegisterPharmacistAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RegisterPharmacistUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Registers a new pharmacist user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `registerPharmacistUser$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerPharmacistUser$Plain(params: {
    body: BackendCoreApiModelsIdentityRegisterPharmacistAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.registerPharmacistUser$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Registers a new pharmacist user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerPharmacistUser$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerPharmacistUser$Json$Response(params: {
    body: BackendCoreApiModelsIdentityRegisterPharmacistAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RegisterPharmacistUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Registers a new pharmacist user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `registerPharmacistUser$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerPharmacistUser$Json(params: {
    body: BackendCoreApiModelsIdentityRegisterPharmacistAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.registerPharmacistUser$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation resetPassword
   */
  static readonly ResetPasswordPath = '/api/identity/reset-password';

  /**
   * Reset password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetPassword$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resetPassword$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityResetPasswordRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.ResetPasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Reset password.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resetPassword$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resetPassword$Plain(params: {
    body: BackendCoreApiModelsIdentityResetPasswordRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.resetPassword$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Reset password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetPassword$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resetPassword$Json$Response(params: {
    body: BackendCoreApiModelsIdentityResetPasswordRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.ResetPasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Reset password.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resetPassword$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resetPassword$Json(params: {
    body: BackendCoreApiModelsIdentityResetPasswordRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.resetPassword$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation revokeToken
   */
  static readonly RevokeTokenPath = '/api/identity/revoke-token';

  /**
   * Revoke token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeToken$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeToken$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RevokeTokenPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Revoke token.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `revokeToken$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeToken$Plain(params?: {
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.revokeToken$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Revoke token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeToken$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeToken$Json$Response(params?: {
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.RevokeTokenPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Revoke token.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `revokeToken$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeToken$Json(params?: {
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.revokeToken$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation verifyAccount
   */
  static readonly VerifyAccountPath = '/api/identity/verify-account';

  /**
   * Verify a new user account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyAccount$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyAccount$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityVerifyAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyAccountPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Verify a new user account.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyAccount$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyAccount$Plain(params: {
    body: BackendCoreApiModelsIdentityVerifyAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.verifyAccount$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Verify a new user account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyAccount$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyAccount$Json$Response(params: {
    body: BackendCoreApiModelsIdentityVerifyAccountRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyAccountPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Verify a new user account.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyAccount$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyAccount$Json(params: {
    body: BackendCoreApiModelsIdentityVerifyAccountRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.verifyAccount$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation verifyAccountThenAuthenticate
   */
  static readonly VerifyAccountThenAuthenticatePath = '/api/identity/verify-account-auth';

  /**
   * Verify a new user account and authenticate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyAccountThenAuthenticate$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyAccountThenAuthenticate$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityVerifyAccountRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyAccountThenAuthenticatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>;
      })
    );
  }

  /**
   * Verify a new user account and authenticate.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyAccountThenAuthenticate$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyAccountThenAuthenticate$Plain(params: {
    body: BackendCoreApiModelsIdentityVerifyAccountRequest
  }): Observable<BackendCoreApiModelsIdentityAuthenticateResponse> {

    return this.verifyAccountThenAuthenticate$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>) => r.body as BackendCoreApiModelsIdentityAuthenticateResponse)
    );
  }

  /**
   * Verify a new user account and authenticate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyAccountThenAuthenticate$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyAccountThenAuthenticate$Json$Response(params: {
    body: BackendCoreApiModelsIdentityVerifyAccountRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyAccountThenAuthenticatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>;
      })
    );
  }

  /**
   * Verify a new user account and authenticate.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyAccountThenAuthenticate$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyAccountThenAuthenticate$Json(params: {
    body: BackendCoreApiModelsIdentityVerifyAccountRequest
  }): Observable<BackendCoreApiModelsIdentityAuthenticateResponse> {

    return this.verifyAccountThenAuthenticate$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAuthenticateResponse>) => r.body as BackendCoreApiModelsIdentityAuthenticateResponse)
    );
  }

  /**
   * Path part for operation verifyDestroyToken
   */
  static readonly VerifyDestroyTokenPath = '/api/identity/verify-destroy-token';

  /**
   * Verifies destroy account token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyDestroyToken$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyDestroyToken$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityVerifyDestroyTokenRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyDestroyTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Verifies destroy account token.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyDestroyToken$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyDestroyToken$Plain(params: {
    body: BackendCoreApiModelsIdentityVerifyDestroyTokenRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.verifyDestroyToken$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Verifies destroy account token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyDestroyToken$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyDestroyToken$Json$Response(params: {
    body: BackendCoreApiModelsIdentityVerifyDestroyTokenRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyDestroyTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Verifies destroy account token.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyDestroyToken$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyDestroyToken$Json(params: {
    body: BackendCoreApiModelsIdentityVerifyDestroyTokenRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.verifyDestroyToken$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation verifyPharmacist
   */
  static readonly VerifyPharmacistPath = '/api/identity/verify-pharmacist';

  /**
   * Verify pharmacist.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyPharmacist$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyPharmacist$Plain$Response(params?: {
    body?: BackendCoreApiModelsIdentityVerifyPharmacistRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyPharmacistPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Verify pharmacist.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyPharmacist$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyPharmacist$Plain(params?: {
    body?: BackendCoreApiModelsIdentityVerifyPharmacistRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.verifyPharmacist$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Verify pharmacist.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyPharmacist$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyPharmacist$Json$Response(params?: {
    body?: BackendCoreApiModelsIdentityVerifyPharmacistRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyPharmacistPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Verify pharmacist.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyPharmacist$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyPharmacist$Json(params?: {
    body?: BackendCoreApiModelsIdentityVerifyPharmacistRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.verifyPharmacist$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation verifyResetToken
   */
  static readonly VerifyResetTokenPath = '/api/identity/verify-reset-token';

  /**
   * Verifies password reset token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyResetToken$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyResetToken$Plain$Response(params: {
    body: BackendCoreApiModelsIdentityVerifyResetTokenRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyResetTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Verifies password reset token.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyResetToken$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyResetToken$Plain(params: {
    body: BackendCoreApiModelsIdentityVerifyResetTokenRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.verifyResetToken$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Verifies password reset token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyResetToken$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyResetToken$Json$Response(params: {
    body: BackendCoreApiModelsIdentityVerifyResetTokenRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IdentityBackendService.VerifyResetTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Verifies password reset token.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyResetToken$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  verifyResetToken$Json(params: {
    body: BackendCoreApiModelsIdentityVerifyResetTokenRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.verifyResetToken$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
